import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { F_STR } from 'assets/FormatNumbers'
import { keyInfo } from 'types/ReferTypes'
import { resLogin } from 'utils/requestUtil'

type LoginState = {
  loginKbn: 0 | 1 | 2 // ログイン判定区分(0: ログイン前、1: 仮ログイン、2: ログイン後)
  MAIL: string // メールアドレス
  NAME: string // ログインユーザー名
  keyInfo: keyInfo[] // ユーザー情報(事業所コード, 仕入先コード, 得意先コード)
  isJapell: boolean // ジャペル社員かどうか
  isSuper: boolean // スーパーユーザーかどうか
}
const initialState: LoginState = {
  loginKbn: 0, // ログイン判定区分(0: ログイン前、1: 仮ログイン、2: ログイン後)
  MAIL: F_STR, // メールアドレス
  NAME: F_STR, // ログインユーザー名
  keyInfo: [
    {
      JIGYO_CD: -1,
      TOKUI_CD: -1,
      TEN_CD: -1,
    },
  ], // ユーザー情報(事業所コード, 仕入先コード, 得意先コード)
  isJapell: false, // ジャペル社員かどうか
  isSuper: false, // スーパーユーザーかどうか
}
export const LoginSlice = createSlice({
  name: 'Login',
  initialState: initialState,
  reducers: {
    // ログイン判定区分を変更 //===========================//
    changeLoginKbn: (state, action: PayloadAction<0 | 1 | 2>) => {
      state.loginKbn = action.payload
    },
    // ログイン後に取得する各情報を変更 //===========================//
    changeLoginInfo: (state, action: PayloadAction<resLogin>) => {
      const payload = action.payload
      state.loginKbn = payload.loginKbn
      state.MAIL = payload.MAIL
      state.NAME = payload.NAME
      state.keyInfo = payload.keyInfo
      state.isJapell = payload.isJapell
      state.isSuper = payload.isSuper
    },
    // ログイン情報 初期化 //===========================//
    format: (state) => {
      for (const key in state) {
        const tempKey: keyof LoginState = key as keyof LoginState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
      sessionStorage.clear()
    },
  },
})

// actionCreator 書き忘れないこと！
export const {
  changeLoginKbn, // ログイン判定区分を変更
  changeLoginInfo, // ログイン後に取得する各情報を変更
  format, // ログイン情報 初期化
} = LoginSlice.actions
export default LoginSlice.reducer
